import React from "react";
import { Button, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function Campaigns({ nextStep, prevStep }) {
  return (
    <>
      <div className="form-navigator-body">
        <Table bordered>
          <thead>
            <tr className="table-secondary align-middle text-center">
              <th>Campaign</th>
              <th>Number of Camps organized during the reporting period</th>
              <th>No of camps visited by DISHA team</th>
              <th>Cumulative Coverage of the reported month</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
          <tr>
            <td>IHC Campaign</td>
            <td><input type="text" className="text-cnter" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-cnter" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-cnter" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-cnter" placeholder="Please Enter"/></td>
          </tr>
          <tr>
            <td>Any other</td>
            <td><input type="text" className="text-cnter" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-cnter" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-cnter" placeholder="Please Enter"/></td>
            <td><input type="text" className="text-cnter" placeholder="Please Enter"/></td>
          </tr>
          </tbody>
        </Table>
      </div>

      <div className="form-navigate-footer">
        <button onClick={prevStep} className="btn btn-outline-secondary">
          Back
        </button>
        <button onClick={nextStep} className="btn btn-dark border-0">
          Next
        </button>
      </div>
    </>
  );
}
